import { FC } from "react";

//!STYLE
import Latex from "react-latex-next";
import s from "./assets/cardResult.module.css";

interface Props {
  res: any;
}
const CardResult: FC<Props> = ({ res }) => {
  return (
    <div className={s.body}>
      <h4 className={s.question}>
        <Latex>
          {res?.question?.title
            ? res?.question?.title.replace("amp;", "").replace("<br />", "")
            : ""}
        </Latex>
      </h4>
      <div
        className={`${s.cardResult} ${res?.answer?.isCorrect ? `${s.isCorrect}` : `${s.isNoCorrect}`
          }`}
      >
        <span>
          <Latex>
            {res?.answer?.title
              ? res?.answer?.title.replace("amp;", "").replace("<br />", "")
              : ""}
          </Latex>
        </span>
      </div>
    </div>
  );
};

export default CardResult;
